import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_5 = { class: "game-add" }
const _hoisted_6 = { class: "game-search" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "onChange", "checked"]

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";
import trim from "lodash-es/trim";

import { toast } from "@/common/utils/toast";
import { getDate, getHour } from "@/common/utils/dates";

import {
  consoleAccessoryConsoleList,
  consoleAccessoryListConsoleIdByAccessory,
  consoleAccessoryCreate,
  consoleAccessoryDelete,
} from "@/common/api/rest/console/accessory";

import { consoleList } from "@/common/api/rest/console/console";

import type { ConsoleAccessoryType } from "@/common/types/console/accessory";
import type { ConsoleType } from "@/common/types/console/console";

import {
  baseAvatar,
  baseConfirm,
  baseLoading,
  baseInput,
  baseModal,
  baseTable,
  svgIcon,
} from "@/common/components";

interface ConsoleIdType {
  item_id: string;
  console_id: string;
  game_id: string;
}

const imageSize = "15rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'console',
  props: {
    ownerId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v72c3f910": (imageSize)
}))

const { t, locale } = useI18n();

const props = __props;

const consoles = ref<ConsoleAccessoryType[]>([]);
const consoleIds = ref<ConsoleIdType[]>([]);
const selected = ref<ConsoleAccessoryType | null>(null);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const loading = ref(true);
const showModalAddConsole = ref(false);
const showModalRemoveConsole = ref(false);

const consoleSearchListRef = ref<any>(null);
const consoleSearch = ref<string>("");
const consoleSearchList = ref<ConsoleType[]>([]);
const consoleLimit = ref<number>(10);
const consolePage = ref<number>(0);
const consolePages = ref<number>(0);
const consoleSearched = ref<number>(0);
const consoleTotal = ref<number>(0);
const loadingMoreConsoles = ref(false);

const tableHeader = computed(() => [
  { key: "avatar", label: "" },
  { key: "name", label: t("common.labels.name") },
  { key: "created", label: t("common.labels.created") },
]);

async function fetchConsoles() {
  await consoleAccessoryConsoleList(props.ownerId, {
    page: page.value,
    limit: limit.value,
    search: search.value,
    sort: "DESC",
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        consoles.value = data.list;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchConsoleId() {
  await consoleAccessoryListConsoleIdByAccessory(props.ownerId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        consoleIds.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function searchConsoles(append = false) {
  if (
    append &&
    (loadingMoreConsoles.value || consolePage.value + 1 >= consolePages.value)
  ) {
    return;
  }

  if (append) {
    loadingMoreConsoles.value = true;
  }

  const pageToFetch = append ? consolePage.value + 1 : 0;

  await consoleList({
    page: pageToFetch,
    limit: consoleLimit.value,
    search: consoleSearch.value,
    sort: "ASC",
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        const newItems = data.list ?? [];
        consoleSearchList.value = append
          ? [...consoleSearchList.value, ...newItems]
          : newItems;
        consolePage.value = pageToFetch;
        consolePages.value = data.infos.pages;
        consoleTotal.value = data.infos.total;
        consoleSearched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loadingMoreConsoles.value = false;
    });
}

function changePage(value: number) {
  page.value = value;
  fetchConsoles();
}

function searchItem(value: string) {
  search.value = value;

  fetchConsoles();
}

function resetSearchConsole() {
  consoleSearch.value = "";
  consoleSearchList.value = [];
  consolePage.value = 0;
  consolePages.value = 0;
  consoleSearched.value = 0;
  consoleTotal.value = 0;
  loadingMoreConsoles.value = false;
}

async function addConsole() {
  store.commit("SET_LOADING", true);

  resetSearchConsole();
  await searchConsoles();
  store.commit("SET_LOADING", false);

  showModalAddConsole.value = true;
}

async function searchConsole() {
  consoleSearchList.value = [];
  consolePage.value = 0;
  consolePages.value = 0;
  consoleSearched.value = 0;
  consoleTotal.value = 0;

  await searchConsoles();
}

function onConsoleListScroll(event: Event) {
  const target =
    (event.target as HTMLElement | null) ?? consoleSearchListRef.value;

  if (!target) {
    return;
  }

  const reachedEnd =
    target.scrollTop + target.clientHeight >= target.scrollHeight - 24;

  if (
    reachedEnd &&
    !loadingMoreConsoles.value &&
    consolePage.value + 1 < consolePages.value
  ) {
    void searchConsoles(true);
  }
}

async function selectConsole(console: ConsoleType) {
  if (!consoleIds.value.some((c) => c.console_id === console.console_id)) {
    await consoleAccessoryCreate(console.console_id, {
      accessory_id: props.ownerId,
    })
      .then((response) => {
        const { success, message } = response;

        if (success) {
          fetchConsoleId();
          fetchConsoles();
        } else {
          toast({ message: message, type: "error" });
        }
      })
      .catch(() => {
        toast({ message: t("error.default"), type: "error" });
      });
  } else {
    const item = consoleIds.value.find(
      (c) => c.console_id === console.console_id,
    );

    await consoleAccessoryDelete(item.item_id)
      .then((response) => {
        const { success, message } = response;

        if (success) {
          fetchConsoleId();
          fetchConsoles();
        } else {
          toast({ message: message, type: "error" });
        }
      })
      .catch(() => {
        toast({ message: t("error.default"), type: "error" });
      });
  }
}

function removeConsole(accessory: ConsoleAccessoryType) {
  selected.value = accessory;
  showModalRemoveConsole.value = true;
}

function removeConsoleCancel() {
  selected.value = null;
  showModalRemoveConsole.value = false;
}

async function removeConsoleConfirm() {
  if (!selected.value) {
    return;
  }

  await consoleAccessoryDelete(selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchConsoleId();
        fetchConsoles();
        showModalRemoveConsole.value = false;
        selected.value = null;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => consoleSearch.value,
  () => {
    if (trim(consoleSearch.value).length === 0) {
      searchConsole();
    }
  },
);

onMounted(async () => {
  await fetchConsoles();
  await fetchConsoleId();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(svgIcon), {
          icon: "no-image",
          size: "2rem"
        }),
        _createTextVNode(" " + _toDisplayString(_unref(t)("collection.labels.consoles")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(baseLoading))
            ]))
          : (_openBlock(), _createBlock(_unref(baseTable), {
              key: 1,
              header: tableHeader.value,
              data: consoles.value,
              limit: limit.value,
              page: page.value,
              pages: pages.value,
              total: total.value,
              searched: searched.value,
              options: true,
              copy: false,
              edit: false,
              del: true,
              "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
              onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
              "onBtn:add": addConsole,
              "onBtn:del": _cache[2] || (_cache[2] = ($event: any) => (removeConsole($event)))
            }, {
              avatar: _withCtx(({ data }) => [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  "is-edit": false,
                  "show-image": true,
                  url: data?.avatar?.large,
                  "aspect-ratio": 1.333,
                  size: "3rem",
                  "border-radius": "0.25rem"
                }, null, 8, ["url"])
              ]),
              created: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(getDate)(data.created)) + " - " + _toDisplayString(_unref(getHour)(data.created)), 1)
              ]),
              _: 1
            }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"]))
      ])
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalRemoveConsole.value,
      title: _unref(t)('collection.modals.titles.del_console').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.del_console', {
        name: selected.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (removeConsoleCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (removeConsoleConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalAddConsole.value,
      title: _unref(t)('collection.modals.titles.add_console').toUpperCase(),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showModalAddConsole.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(baseInput), {
              modelValue: consoleSearch.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((consoleSearch).value = $event)),
              background: "#fff",
              color: "#000",
              placeholder: _unref(t)('common.labels.search'),
              "onKey:enter": _cache[7] || (_cache[7] = ($event: any) => (searchConsole()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (searchConsole()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", {
            ref_key: "consoleSearchListRef",
            ref: consoleSearchListRef,
            class: "game-list",
            onScroll: onConsoleListScroll
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consoleSearchList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "game"
              }, [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  "is-edit": false,
                  "show-image": true,
                  url: item?.avatar?.large,
                  "aspect-ratio": 1.333,
                  size: "3rem",
                  "border-radius": "0.25rem"
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                _createElementVNode("label", {
                  class: "custom-checkbox",
                  for: `console-${item.console_id}`
                }, [
                  _createElementVNode("input", {
                    id: `console-${item.console_id}`,
                    class: "checkbox-input",
                    type: "checkbox",
                    onChange: ($event: any) => (selectConsole(item)),
                    checked: 
                    consoleIds.value.some((c) => c.console_id === item.console_id)
                  
                  }, null, 40, _hoisted_10),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "checkbox-mark" }, null, -1))
                ], 8, _hoisted_9)
              ]))
            }), 128))
          ], 544)
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})